__turbopack_export_value__({
  "body-logo-18": "Modal-module-scss-module__yswRDq__body-logo-18",
  "body-text-12": "Modal-module-scss-module__yswRDq__body-text-12",
  "body-text-14": "Modal-module-scss-module__yswRDq__body-text-14",
  "body-text-16": "Modal-module-scss-module__yswRDq__body-text-16",
  "body-text-18": "Modal-module-scss-module__yswRDq__body-text-18",
  "body-text-20": "Modal-module-scss-module__yswRDq__body-text-20",
  "body-text-24": "Modal-module-scss-module__yswRDq__body-text-24",
  "body-text-24-2": "Modal-module-scss-module__yswRDq__body-text-24-2",
  "body-text-heading-2": "Modal-module-scss-module__yswRDq__body-text-heading-2",
  "body-text-heading-3": "Modal-module-scss-module__yswRDq__body-text-heading-3",
  "body-text-medium-14": "Modal-module-scss-module__yswRDq__body-text-medium-14",
  "body-text-medium-16": "Modal-module-scss-module__yswRDq__body-text-medium-16",
  "body-text-medium-18": "Modal-module-scss-module__yswRDq__body-text-medium-18",
  "body-text-medium2-18": "Modal-module-scss-module__yswRDq__body-text-medium2-18",
  "body-text2-14": "Modal-module-scss-module__yswRDq__body-text2-14",
  "body-text2-16": "Modal-module-scss-module__yswRDq__body-text2-16",
  "button-primary-text": "Modal-module-scss-module__yswRDq__button-primary-text",
  "button-text": "Modal-module-scss-module__yswRDq__button-text",
  "button2-text": "Modal-module-scss-module__yswRDq__button2-text",
  "card-shadow": "Modal-module-scss-module__yswRDq__card-shadow",
  "effect-menu": "Modal-module-scss-module__yswRDq__effect-menu",
  "header-1": "Modal-module-scss-module__yswRDq__header-1",
  "main-container": "Modal-module-scss-module__yswRDq__main-container",
  "main-footer-container": "Modal-module-scss-module__yswRDq__main-footer-container",
  "main-header-container": "Modal-module-scss-module__yswRDq__main-header-container",
  "modal": "Modal-module-scss-module__yswRDq__modal",
  "modal__close": "Modal-module-scss-module__yswRDq__modal__close",
  "modal__container": "Modal-module-scss-module__yswRDq__modal__container",
  "txt-12-bold": "Modal-module-scss-module__yswRDq__txt-12-bold",
  "txt-14-bold": "Modal-module-scss-module__yswRDq__txt-14-bold",
  "txt-14-bold-caps": "Modal-module-scss-module__yswRDq__txt-14-bold-caps",
  "txt-14-med": "Modal-module-scss-module__yswRDq__txt-14-med",
  "txt-16-bold": "Modal-module-scss-module__yswRDq__txt-16-bold",
  "txt-16-med": "Modal-module-scss-module__yswRDq__txt-16-med",
  "txt-18-bold": "Modal-module-scss-module__yswRDq__txt-18-bold",
  "txt-18-medium": "Modal-module-scss-module__yswRDq__txt-18-medium",
  "txt-18-medium-24": "Modal-module-scss-module__yswRDq__txt-18-medium-24",
  "txt-24-semi": "Modal-module-scss-module__yswRDq__txt-24-semi",
});
